export default "__VITE_ASSET__Cqiz6YD6__"